module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "boxs"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v(" 选择登录企业 ")]), _vm._v(" "), _c('div', {
    staticClass: "company-list"
  }, [_c('div', {
    staticClass: "lcpmpy"
  }, [_c('ul', {
    staticClass: "lcompy-list",
    style: ({
      marginLeft: _vm.marginleftwidth + 'px'
    })
  }, [_c('li', {
    class: {
      active: _vm.tindex == 0
    },
    on: {
      "click": _vm.addCompany
    }
  }, [_c('div', {
    staticClass: "lcompy-img"
  }, [_c('img', {
    attrs: {
      "src": require('@/assets/images/add_btn.png')
    }
  })]), _vm._v(" "), (_vm.tindex == 0) ? _c('p', {
    staticClass: "lcompy-name"
  }, [_vm._v("添加企业")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.compyList), function(item, index) {
    return _c('li', {
      key: index,
      class: {
        active: _vm.tindex == index + 1
      },
      on: {
        "click": function($event) {
          _vm.selCompany(index)
        }
      }
    }, [_c('div', {
      staticClass: "lcompy-img"
    }, [_c('img', {
      attrs: {
        "src": item.logo
      }
    })]), _vm._v(" "), (_vm.tindex == index + 1) ? _c('p', {
      staticClass: "lcompy-name"
    }, [_vm._v(_vm._s(item.shortName))]) : _vm._e()])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-leftback_ico to-left",
    class: {
      blue: _vm.letfCan
    },
    on: {
      "click": _vm.goleft
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "iconfont icon-rightbright to-right",
    class: {
      blue: _vm.rightCan
    },
    on: {
      "click": _vm.goright
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "primary-btn",
    on: {
      "click": _vm.goindex
    }
  }, [_vm._v("确定")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75af8206","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login/select.vue
// module id = 895
// module chunks = 1